import {Component} from '@angular/core';

@Component({
  standalone: false,
  selector: 'indosuara-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'pos';
}
